import clsx from 'clsx';

import ChevronLeft from '~/icons/chevron-left.svg';
import { Icon } from '~/shared/components/Icon/Icon';
import styles from '~/templates/blocks/components/N55Breadcrumb/N55Breadcrumb.module.css';

import Link from '../Link/Link';

export const BreadcrumbLink = ({ url, text, className, omitIcon }: { url: string; text: string; className?: string; omitIcon?: boolean }) => {
	return (
		<Link
			href={url}
			isCustomStyle
			className={clsx(styles.breadcrumb, className)}
		>
			{!omitIcon ? (
				<Icon className={styles.icon}>
					<ChevronLeft />
				</Icon>
			) : null}
			<span>{text}</span>
		</Link>
	);
};
